const STORAGE_KEY = 'cfamex:presenceSessionId';

const createSessionId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `sess-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const readMemoryId = () => (
    typeof window !== 'undefined' ? window.__cfamexPresenceSessionId : ''
);

const writeMemoryId = (id) => {
    if (typeof window !== 'undefined') {
        window.__cfamexPresenceSessionId = id;
    }
};

const readFromStore = (store) => {
    try {
        return store?.getItem(STORAGE_KEY) || '';
    } catch {
        return '';
    }
};

const writeToStore = (store, id) => {
    try {
        store.setItem(STORAGE_KEY, id);
        return readFromStore(store) || id;
    } catch {
        return '';
    }
};

const writeSessionId = (id) => {
    const fromLocal = typeof localStorage !== 'undefined'
        ? writeToStore(localStorage, id)
        : '';
    if (fromLocal) {
        writeMemoryId(fromLocal);
        return fromLocal;
    }

    const fromSession = typeof sessionStorage !== 'undefined'
        ? writeToStore(sessionStorage, id)
        : '';
    if (fromSession) {
        writeMemoryId(fromSession);
        return fromSession;
    }

    writeMemoryId(id);
    return id;
};

export const getPresenceSessionId = () => {
    const fromLocal = typeof localStorage !== 'undefined' ? readFromStore(localStorage) : '';
    if (fromLocal) {
        writeMemoryId(fromLocal);
        return fromLocal;
    }

    const fromSession = typeof sessionStorage !== 'undefined' ? readFromStore(sessionStorage) : '';
    if (fromSession) {
        return writeSessionId(fromSession);
    }

    const fromMemory = readMemoryId();
    if (fromMemory) return fromMemory;

    return writeSessionId(createSessionId());
};

export const rotatePresenceSessionId = () => writeSessionId(createSessionId());
